import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentFilledSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 5a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H8l-5 5V5Z" />
  </svg>
);
export default IconCommentFilledSizeL;
